// import React, { useState } from "react"
// import {
//   Card,
//   CardBody,
//   CardTitle,
//   FormGroup,
//   Label,
//   Input,
//   Button,
//   Row,
//   Col,
//   Progress, // ← Added for progress bar
//   Alert, // ← Optional success message
// } from "reactstrap"

// const UploadSection = () => {
//   const [selectedFile, setSelectedFile] = useState(null)
//   const [progress, setProgress] = useState(0)
//   const [uploading, setUploading] = useState(false)
//   const [uploadComplete, setUploadComplete] = useState(false)

//   const handleFileChange = e => {
//     if (e.target.files && e.target.files[0]) {
//       setSelectedFile(e.target.files[0])
//       setProgress(0) // reset progress
//       setUploadComplete(false) // reset success
//     }
//   }

//   const simulateUpload = () => {
//     setUploading(true)
//     setProgress(0)
//     setUploadComplete(false)

//     // Yeh sirf demo ke liye hai — real API call ke time hata dena
//     let currentProgress = 0
//     const interval = setInterval(() => {
//       currentProgress += Math.random() * 10 + 5 // random speed feel
//       if (currentProgress >= 100) {
//         currentProgress = 100
//         clearInterval(interval)
//         setProgress(100)
//         setTimeout(() => {
//           setUploading(false)
//           setUploadComplete(true)
//           // setSelectedFile(null)   // ← Uncomment if you want to reset file after success
//         }, 600)
//       } else {
//         setProgress(Math.min(currentProgress, 100))
//       }
//     }, 300)

//     // Real backend call example (commented):
//     /*
//     const formData = new FormData()
//     formData.append("file", selectedFile)

//     const xhr = new XMLHttpRequest()
//     xhr.open("POST", "/api/upload", true)

//     xhr.upload.onprogress = (event) => {
//       if (event.lengthComputable) {
//         const percent = Math.round((event.loaded / event.total) * 100)
//         setProgress(percent)
//       }
//     }

//     xhr.onload = () => {
//       if (xhr.status === 200) {
//         setUploadComplete(true)
//       }
//       setUploading(false)
//     }

//     xhr.send(formData)
//     */
//   }

//   const handleUpload = () => {
//     if (!selectedFile) {
//       alert("Please select a file first!")
//       return
//     }

//     // alert(`Uploading file: ${selectedFile.name}`)  // remove this
//     simulateUpload() // ← For demo
//     // Real mein: call your API function here
//   }

//   return (
//     <Card>
//       <CardBody>
//         <CardTitle className="mb-4">Upload New File</CardTitle>

//         <Row className="justify-content-center">
//           <Col md="8" lg="6">
//             <FormGroup>
//               <Label for="fileInput">Choose File</Label>
//               <div className="custom-file">
//                 <Input
//                   type="file"
//                   id="fileInput"
//                   onChange={handleFileChange}
//                   className="custom-file-input"
//                   disabled={uploading}
//                 />
//                 <Label className="custom-file-label" htmlFor="fileInput">
//                   {selectedFile ? selectedFile.name : "Choose file..."}
//                 </Label>
//               </div>
//             </FormGroup>

//             {selectedFile && !uploading && !uploadComplete && (
//               <p className="text-muted mt-2">
//                 Selected: {selectedFile.name} (
//                 {(selectedFile.size / 1024).toFixed(2)} KB)
//               </p>
//             )}

//             {/* Progress Bar – only shows when uploading */}
//             {uploading && (
//               <div className="mt-4">
//                 <p className="text-primary mb-2">Uploading... {progress}%</p>
//                 <Progress
//                   animated
//                   color="primary"
//                   value={progress}
//                   className="mb-3"
//                 />
//               </div>
//             )}

//             {/* Success Message */}
//             {uploadComplete && (
//               <Alert color="success" className="mt-3">
//                 File uploaded successfully! ({selectedFile?.name})
//               </Alert>
//             )}

//             <Button
//               color="primary"
//               onClick={handleUpload}
//               disabled={!selectedFile || uploading}
//               className="mt-3"
//               block
//             >
//               {uploading
//                 ? "Uploading..."
//                 : uploadComplete
//                 ? "Upload Another File"
//                 : "Upload File"}
//             </Button>
//           </Col>
//         </Row>
//       </CardBody>
//     </Card>
//   )
// }

// export default UploadSection

// import React, { useState } from "react"
// import {
//   Card,
//   CardBody,
//   CardTitle,
//   FormGroup,
//   Label,
//   Input,
//   Button,
//   Row,
//   Col,
//   Progress,
//   Alert,
// } from "reactstrap"

// // Import real upload function
// import { uploadFile } from "../../helpers/api_helper" // path adjust kar lena agar zarurat ho

// const UploadSection = () => {
//   const [selectedFile, setSelectedFile] = useState(null)
//   const [progress, setProgress] = useState(0)
//   const [uploading, setUploading] = useState(false)
//   const [uploadComplete, setUploadComplete] = useState(false)
//   const [uploadMessage, setUploadMessage] = useState("")
//   const [uploadError, setUploadError] = useState(null)

//   const handleFileChange = e => {
//     if (e.target.files && e.target.files[0]) {
//       setSelectedFile(e.target.files[0])
//       setProgress(0)
//       setUploadComplete(false)
//       setUploadMessage("")
//       setUploadError(null)
//     }
//   }

//   const handleUpload = async () => {
//     if (!selectedFile) {
//       alert("Please select a file first!")
//       return
//     }

//     setUploading(true)
//     setProgress(0)
//     setUploadComplete(false)
//     setUploadMessage("")
//     setUploadError(null)

//     try {
//       // Progress simulation (optional – real progress ke liye XMLHttpRequest use kar sakte ho)
//       // Ab real API call
//       const result = await uploadFile(selectedFile)

//       if (result.success) {
//         setUploadMessage(result.message)
//         setUploadComplete(true)
//       } else {
//         setUploadError(result.error)
//       }
//     } catch (err) {
//       setUploadError(err.message || "Upload failed. Please try again.")
//     } finally {
//       setUploading(false)
//     }
//   }

//   return (
//     <Card>
//       <CardBody>
//         <CardTitle className="mb-4">Upload New File</CardTitle>

//         <Row className="justify-content-center">
//           <Col md="8" lg="6">
//             <FormGroup>
//               <Label for="fileInput">Choose File</Label>
//               <div className="custom-file">
//                 <Input
//                   type="file"
//                   id="fileInput"
//                   onChange={handleFileChange}
//                   className="custom-file-input"
//                   disabled={uploading}
//                 />
//                 <Label className="custom-file-label" htmlFor="fileInput">
//                   {selectedFile ? selectedFile.name : "Choose file..."}
//                 </Label>
//               </div>
//             </FormGroup>

//             {selectedFile && !uploading && !uploadComplete && (
//               <p className="text-muted mt-2">
//                 Selected: {selectedFile.name} (
//                 {(selectedFile.size / 1024).toFixed(2)} KB)
//               </p>
//             )}

//             {/* Progress Bar – only shows when uploading */}
//             {uploading && (
//               <div className="mt-4">
//                 <p className="text-primary mb-2">Uploading... {progress}%</p>
//                 <Progress
//                   animated
//                   color="primary"
//                   value={progress}
//                   className="mb-3"
//                 />
//               </div>
//             )}

//             {/* Success Message */}
//             {uploadComplete && uploadMessage && (
//               <Alert color="success" className="mt-3">
//                 {uploadMessage}
//               </Alert>
//             )}

//             {/* Error Message */}
//             {uploadError && (
//               <Alert color="danger" className="mt-3">
//                 {uploadError}
//               </Alert>
//             )}

//             <Button
//               color="primary"
//               onClick={handleUpload}
//               disabled={!selectedFile || uploading}
//               className="mt-3"
//               block
//             >
//               {uploading
//                 ? "Uploading..."
//                 : uploadComplete
//                 ? "Upload Another File"
//                 : "Upload File"}
//             </Button>
//           </Col>
//         </Row>
//       </CardBody>
//     </Card>
//   )
// }

// export default UploadSection

import React, { useState } from "react"
import {
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Progress,
  Alert,
} from "reactstrap"

// Real upload function import
import { uploadFile } from "../../helpers/api_helper" // path adjust kar lena agar alag folder mein hai

const UploadSection = () => {
  const [selectedFile, setSelectedFile] = useState(null)
  const [progress, setProgress] = useState(0)
  const [uploading, setUploading] = useState(false)
  const [uploadComplete, setUploadComplete] = useState(false)
  const [uploadMessage, setUploadMessage] = useState("")
  const [uploadError, setUploadError] = useState(null)

  const handleFileChange = e => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0])
      setProgress(0)
      setUploadComplete(false)
      setUploadMessage("")
      setUploadError(null)
    }
  }

  const handleUpload = async () => {
    if (!selectedFile) {
      alert("Please select a file first!")
      return
    }

    setUploading(true)
    setProgress(0)
    setUploadComplete(false)
    setUploadMessage("")
    setUploadError(null)

    try {
      // Real API call
      const result = await uploadFile(selectedFile)

      if (result.success) {
        // Backend ka message dikhao
        setUploadMessage(result.message || "File uploaded successfully!")

        // StatsCards ko refresh karne ke liye event fire karo (poora data bhej rahe hain)
        window.dispatchEvent(
          new CustomEvent("upload-success", { detail: result.data })
        )

        setUploadComplete(true)
      } else {
        setUploadError(result.error || "Upload failed")
      }
    } catch (err) {
      setUploadError(err.message || "Something went wrong during upload")
    } finally {
      setUploading(false)
    }
  }

  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">Upload New File</CardTitle>

        <Row className="justify-content-center">
          <Col md="8" lg="6">
            <FormGroup>
              <Label for="fileInput">Choose File</Label>
              <div className="custom-file">
                <Input
                  type="file"
                  id="fileInput"
                  onChange={handleFileChange}
                  className="custom-file-input"
                  disabled={uploading}
                  accept=".csv,.xlsx,.xls"
                />
                <Label className="custom-file-label" htmlFor="fileInput">
                  {selectedFile ? selectedFile.name : "Choose file..."}
                </Label>
              </div>
            </FormGroup>

            {selectedFile && !uploading && !uploadComplete && (
              <p className="text-muted mt-2">
                Selected: {selectedFile.name} (
                {(selectedFile.size / 1024).toFixed(2)} KB)
              </p>
            )}

            {/* Progress Bar */}
            {uploading && (
              <div className="mt-4">
                <p className="text-primary mb-2">Uploading... {progress}%</p>
                <Progress
                  animated
                  color="primary"
                  value={progress}
                  className="mb-3"
                />
              </div>
            )}

            {/* Success Message */}
            {uploadComplete && uploadMessage && (
              <Alert color="success" className="mt-3">
                {uploadMessage}
              </Alert>
            )}

            {/* Error Message */}
            {uploadError && (
              <Alert color="danger" className="mt-3">
                {uploadError}
              </Alert>
            )}

            <Button
              color="primary"
              onClick={handleUpload}
              disabled={!selectedFile || uploading}
              className="mt-3"
              block
            >
              {uploading
                ? "Uploading..."
                : uploadComplete
                ? "Upload Another File"
                : "Upload File"}
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default UploadSection
